/* eslint-disable react/prop-types */
import React from 'react';
import Proptypes from 'prop-types';
import { NavLink } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import parse from 'html-react-parser';
import NormalButton from '../../../components/Buttons/NormalButton';
import policy from '../../assets/images/policy.jpg';

function LatestArticles(props) {
  const {
    articles, errorStatus, sucessStatus,
  } = props;
  let content;
  if (errorStatus) {
    content = <div className="text-red-500">An error occurred while fetching the articles</div>;
  } else if (sucessStatus) {
    content = (
      <div className="flex md:flex-nowrap flex-wrap gap-2 xl:px-24 lg:p-16 md:p-8 p-4">
        <NavLink
          to={`/public/article/${articles[0].id}`}
          key={articles[0].id}
          className="md:w-1/2 w-full p-2 md:pr-16 pr-4 border border-gray-200 flex flex-col"
        >
          <h1 className="font-semibold xl:text-2xl lg:text-xl text-md my-4">Latest Article</h1>
          <div className="flex flex-col gap-2">
            <div className="w-full xl:h-96 lg:h-60 md:h-48 h-36 bg-contain bg-no-repeat" style={{ backgroundImage: `url(${policy})` }}>.</div>
            <div className="p-2 flex items-center gap-2 lg:flex-nowrap flex-wrap">
              <h3 className="xl:text-lg lg:text-md text-sm text-blue-500">{`By ${articles[0].name} on `}</h3>
              <p className="text-gray-600lg:text-lg  text-sm">
                {new Date(articles[0].post_date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            </div>
          </div>
          <h2 className="font-bold xl:text-xl lg:text-xl text-md text-gray-700 my-2 px-2">
            {articles[0].post_title}
          </h2>
          <p className="xl:text-lg lg:md md:text-sm text-xs text-gray-700 my-1 mb-8 px-2">
            {parse(articles[0].post_content.length > 200
              ? `${articles[0].post_content.substring(0, 200)} [...]`
              : articles[0].post_content)}
          </p>
          <NormalButton buttonText="Read More . . ." />
        </NavLink>
        <div className="md:w-1/2 w-full p-2 flex flex-col">
          <div className="flex items-center justify-between">
            <h1 className="font-semibold xl:text-xl lg:text-lg text-md my-4">More Articles</h1>
            <NavLink to="/public/articles/" className="text-blue-500 hover:text-blue-700 font-semibold xl:text-xl lg:text-lg text-md">
              View All
            </NavLink>

          </div>
          <div className="flex flex-col gap-2">
            {articles.slice(1, 6).map((article) => (
              <NavLink
                to={`/public/article/${article.id}`}
                key={article.id}
                className="flex gap-1 p-2 md:py-6 py-3 hover:bg-sky-50"
                article={article}
              >
                <div className="w-1/5 h-16 bg-[url('public/assets/images/policy.jpg')] bg-contain bg-no-repeat">.</div>
                <div className="flex flex-col">
                  <h2 className="font-semibold xl:text-lg lg:text-md md:text-sm text-xs text-gray-700 px-2">
                    {article.post_title}
                  </h2>
                  <p className="text-gray-600 xl:text-sm lg:text-xs text-2xs">
                    {parse(article.post_content.length > 60
                      ? `${article.post_content.substring(0, 60)} [...]`
                      : article.post_content)}
                  </p>
                  <div className="px-2 flex items-center gap-2 lg:flex-nowrap flex-wrap">
                    <h3 className="xl:text-sm lg:text-xs text-2xs text-blue-500">{`By ${article.name} on `}</h3>
                    <p className="text-gray-600 xl:text-sm lg:text-xs text-2xs">
                      {new Date(article.post_date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                    </p>
                  </div>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    );
  }
  return <div id="articleshome" className="latest-articles">{content}</div>;
}

Proptypes.propTypes = {
  articles: Proptypes.isRequired,
  errorStatus: Proptypes.bool.isRequired,
  sucessStatus: Proptypes.bool.isRequired,
  error: Proptypes.isRequired,
};

export default LatestArticles;
